import type { ValueOf } from 'type-fest';

/** Taken from /validate endpoints */
export const accountTerminationReason = {
	feeToHigh: 'ATR_FEE_TOO_HIGH',
	notEnoughProducts: 'ATR_NOT_ENOUGH_PRODUCTS',
	interestRate: 'ATR_INTEREST_RATE',
	confusing: 'ATR_CONFUSING',
	other: 'ATR_OTHER',
	clientRequest: 'ATR_CLIENT_REQUEST',
	aml: 'ATR_AML',
	fraud: 'ATR_FRAUD',
	tocValidation: 'ATR_TOC_VIOLATION',
	bankWithNoticePeriod: 'ATR_BANK_WITH_NOTICE_PERIOD',
	insolvency: 'ATR_INSOLVENCY',
	inheritance: 'ATR_INHERITANCE',
	limitationOfAutonomy: 'ATR_LIMITATION_OF_AUTONOMY',
} as const;

export type AccountTerminationReason = ValueOf<typeof accountTerminationReason>;
